import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../components/ActionButton";
import FormFieldsTable from "../../components/forms/FormFieldsTable";
import TextInputField from "../../components/forms/TextInputField";
import TextAreaInputField from "../../components/forms/TextAreaInputField";
import BooleanInputField from "../../components/forms/BooleanInputField";
import FormError from "../../components/forms/FormError";

function uppercase(value) {
  return value.toUpperCase().trim();
}

class EditReferralCodeForm extends Component {

  render() {
    let {errors, handleSubmit, submit, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 
    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <FormFieldsTable>
            <Field 
              label="Code"
              name="code"
              active={!this.props.disableCode}
              component={TextInputField}
              serverError={this.props.errors.code}
              normalize={uppercase}
              />
            <Field 
              label="Description"
              name="description"
              component={TextAreaInputField}
              serverError={this.props.errors.description}
              />
            <Field 
              label="Active"
              name="active"
              component={BooleanInputField}
              serverError={this.props.errors.active}
              />
          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton label={submitLabel} onClick={submit} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "EditReferralCodeForm"
})(EditReferralCodeForm);

EditReferralCodeForm.defaultProps = {
  disableCode: false
}

export default ReduxForm;